import {
	applySpec,
	equals,
	find,
	keys,
	map,
	path,
	pathOr,
	pick,
	pipe,
	prop,
	propEq,
	reject, invertObj, assoc, pluck, mergeAll, isNil, reduce, concat, propOr,
} from 'ramda';
import { verifyJobIsCompleted } from '@/modules/job-evaluation/helpers/helpers';

export const commandMap = {
	highCommand: 'HIGH',
	mediumCommand: 'MIDDLE',
	lowCommand: 'UNDER',
};

export const commandMapInverted = invertObj(commandMap);
const concatAll = reduce(concat, []);
const getCurrentToolCode = pathOr([], ['mainData', 'code']);
const getCommandByTypeVerb = job => prop(prop('typeVerb', job), commandMapInverted);
const matchWithLocalVerbs = (state, job) => verbCode => find(
	propEq('code', verbCode),
	pipe(
		pathOr([], ['supplies', 'guidelineModel', 'verbsSelection', getCommandByTypeVerb(job), 'details']),
		map(pick(['id', 'name', 'code'])),
	)(state),
);
const parseVerbs = state => job => pipe(
	propOr({}, getCommandByTypeVerb(job)),
	reject(equals(false)),
	keys,
	map(matchWithLocalVerbs(state, job)),
	reject(isNil),
)(job);

export const parseHierarchyAssignation = (assignations) => {
	const overrideVerbStructure = (usedCommand, originalJob) => parsedJob => assoc(
		usedCommand,
		pipe(
			prop('verbsCode'),
			pluck('code'),
			map(k => ({ [k]: true })),
			mergeAll,
		)(originalJob),
		parsedJob,
	);
	const parseJobs = (originalJob) => {
		const usedCommand = prop(prop('typeVerb', originalJob), commandMapInverted);
		return pipe(
			applySpec({
				id: prop('id'),
				name: prop('name'),
				role: prop('roleId'),
				title: prop('titulationId'),
				typeVerb: prop('typeVerb'),
				experience: prop('expirienceTimeId'),
				fatherId: prop('fatherId'),
				fatherName: prop('fatherName'),
				highCommand: () => ({}),
				mediumCommand: () => ({}),
				lowCommand: () => ({}),
			}),
			overrideVerbStructure(usedCommand, originalJob),
			j => assoc('completed', verifyJobIsCompleted(j), j),
		)(originalJob);
	};
	return map(
		applySpec({
			id: prop('id'),
			job: path(['question', 'name']),
			hasError: prop('flagFix'),
			jobPositions: pipe(
				prop('details'),
				map(parseJobs),
			),
		}),
		assignations || [],
	);
};

const toolCommonConfig = {
	name: 'Valoración de puestos',
	languages: {
		SPA: { name: 'Nombre de la encuesta 001' },
		ENG: { name: 'Poll name 001' },
		FRA: { name: 'Nom du sondage 001' },
	},
	stageStatus: 1,
	stageDetailStatus: 1,
};

export const parseAssignationRequest = state => ({
	toolCode: getCurrentToolCode(state),
	...toolCommonConfig,
	jobs: pipe(
		pathOr([], ['supplies', 'guidelineModel', 'userForm', 'jobList']),
		map(applySpec({
			// id: job => prop('id', job) || null,
			father: job => prop('father', job) || null,
			name: prop('name'),
			roleId: prop('role'),
			titulationId: prop('title'),
			expirienceTimeId: prop('experience'),
			typeVerb: prop('typeVerb'),
			verbsCode: parseVerbs(state),
		})),
	)(state),
});

export const parseOrganizationChart = state => ({
	toolCode: getCurrentToolCode(state),
	...toolCommonConfig,
	stageStatus: 1,
	stageDetailStatus: 2,
	jobs: pipe(
		pathOr([], ['supplies', 'guidelineModel', 'hierarchyAssignation']),
		pluck('jobPositions'),
		concatAll,
		map(applySpec({
			father: prop('fatherName'),
			name: prop('name'),
			roleId: prop('role'),
			titulationId: prop('title'),
			expirienceTimeId: prop('experience'),
			typeVerb: prop('typeVerb'),
			verbsCode: parseVerbs(state),
		})),
	)(state),
});

export default {};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/utils/guideline-model/helpers.js